module.exports = __webpack_public_path__ + "static/img/img_tip3.73109118.png";